document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll("[data-sr-counter]");
  if (!counters.length) return;

  const duration = 2000;

  counters.forEach((counter) => {
    const target = Number(counter.getAttribute("data-sr-counter"));
    if (!Number.isFinite(target)) return;

    let startTime = null;
    const plus = counter.getAttribute("data-sr-plus") === "true";

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const value = Math.floor(progress * target);
      counter.textContent = `${value}${plus ? "+" : ""}`;
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  });
});
